import React from "react";
import type { ReactNode } from "react";
import { INK, RULE } from "../styles";

interface TDProps {
  children: ReactNode;
  bold?: boolean;
  num?: boolean;
  colSpan?: number;
}

export default function TD({ children, bold, num, colSpan }: TDProps) {
  return (
    <td
      colSpan={colSpan}
      style={{
        border: "1px solid " + RULE,
        padding: "14px 14px",
        color: INK,
        verticalAlign: "top",
        fontWeight: bold ? 700 : 500,
        fontVariantNumeric: num ? "tabular-nums" : "normal",
      }}
    >
      {children}
    </td>
  );
}